import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fbdbd7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "tabs__tab active" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Varianter")
], -1))
const _hoisted_6 = { class: "tabs__tab" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "tabs__tab" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "tabs__tab" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "tabs__tab" }

import {mdiLoading, mdiMenuDown, mdiMenuUp} from "@mdi/js";

import {ref} from 'vue';
import ProductAttributeComponent from "@/Components/ProductAttributes/ProductAttributeComponent.vue";
import ProductAttribute from "@/types/ProductAttribute";
import ProductAttributeOption from "@/types/ProductAttributeOption";
import Messages from "@/Components/General/Messages.vue";
import ProductFilter from "@/Components/Product/ProductFilter.vue";
import Card from "@/Components/General/Card.vue";
import ProductList from "@/Components/Product/ProductList.vue";
import Button from "@/Components/Buttons/Button.vue";
import Modal from "@/Components/General/Modal.vue";
import {Link, useForm} from "@inertiajs/inertia-vue3";
import {computed} from "@vue/reactivity";
import SvgIcon from "@jamescoyle/vue-icon";
import ValidationErrors from "@/Components/Forms/ValidationErrors.vue";
import ValidationFormErrors from "@/Components/Forms/ValidationFormErrors.vue";
import Changelogs from "@/Components/Product/Changelogs.vue";
import {Inertia} from "@inertiajs/inertia";
import Product from "@/types/Product";
import vueFilePond from 'vue-filepond';

// Import plugins
/** @ts-ignore*/
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
/** @ts-ignore*/
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';

// Import styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import Textarea from "@/Components/Forms/Textarea.vue";
import AttributeOptionsSelect from "@/Components/Forms/AttributeOptionsSelect.vue";
import {PropType} from "vue/dist/vue";
import Pagination from "@/types/Pagination";
import { mdiBasketOutline, mdiPercentOutline } from "@mdi/js";



import AppLayoutVue from "@/Layouts/AppLayout.vue";


const __default__ = {
  layout: AppLayoutVue,

}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Variations',
  props: {
    variations: {},
    product: {},
    isAdmin: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);


const legacyBaseUrl = `/products/view-product/${props.product.id}/`;

const printPriceTag = (isSmall = false, isCampaign = false) => {
  Inertia.post(
      route(`products.label.print${isCampaign ? "-campaign" : ""}`),
      {
        isSmall: isSmall,
      }
  );
};
const addProductLink = computed(() => {
  return "/l-products/new-product/";
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.product.name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Button, {
        color: "primary",
        type: "a",
        class: "actions__button",
        href: "/products/view-product/list-product/"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Tilbake til produktliste ")
        ]),
        _: 1
      }),
      _createVNode(Button, {
        color: "info",
        class: "actions__button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (printPriceTag()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Skriv ut prislapp ")
        ]),
        _: 1
      }),
      _createVNode(Button, {
        color: "info",
        class: "actions__button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (printPriceTag(true)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Skriv ut liten prislapp ")
        ]),
        _: 1
      }),
      _createVNode(Button, {
        color: "info",
        class: "actions__button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (printPriceTag(false, true)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Skriv ut kampanjeprislapp ")
        ]),
        _: 1
      }),
      _createVNode(Button, {
        color: "info",
        class: "actions__button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (printPriceTag(true, true)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Skriv ut liten kampanjeprislapp ")
        ]),
        _: 1
      }),
      _createVNode(Button, {
        color: "yellow",
        type: "a",
        class: "actions__button",
        href: `/products/?duplicate-product=${_ctx.product.id}`
      }, {
        default: _withCtx(() => [
          _createTextVNode("Dupliser produkt ")
        ]),
        _: 1
      }, 8, ["href"])
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", { class: "tabs__tab" }, [
        _createElementVNode("a", { href: legacyBaseUrl }, "Detaljer")
      ]),
      _hoisted_5,
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("a", {
          href: `${legacyBaseUrl}#sale`
        }, "Salg", 8, _hoisted_7)
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createElementVNode("a", {
          href: `${legacyBaseUrl}#gallery`
        }, "Produkt galleri", 8, _hoisted_9)
      ]),
      _createElementVNode("li", _hoisted_10, [
        _createElementVNode("a", {
          href: `${legacyBaseUrl}#statistics`
        }, "Statistikk", 8, _hoisted_11)
      ]),
      _createElementVNode("li", _hoisted_12, [
        _createVNode(_unref(Link), {
          href: _ctx.route('products.changelog', {product:_ctx.product.id})
        }, {
          default: _withCtx(() => [
            _createTextVNode("Endringslogg")
          ]),
          _: 1
        }, 8, ["href"])
      ])
    ]),
    _createVNode(Card, { class: "tab-content" }, {
      default: _withCtx(() => [
        _createVNode(Messages, { class: "product-index-messages" }),
        _createVNode(Button, {
          class: "button-with-icon",
          color: "primary",
          type: "a",
          href: _unref(addProductLink)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SvgIcon), {
              type: "mdi",
              path: _unref(mdiBasketOutline)
            }, null, 8, ["path"]),
            _createTextVNode(" Legg til variant")
          ]),
          _: 1
        }, 8, ["href"]),
        _createVNode(ProductList, {
          products: _ctx.variations,
          isAdmin: _ctx.isAdmin
        }, null, 8, ["products", "isAdmin"])
      ]),
      _: 1
    })
  ]))
}
}

})